module.exports = __webpack_public_path__ + "static/media/hitomi-lose.ae6366a9.png";